@if (tiles$ | async; as list) {
  <div
    class="recent-announcements-tiles-container"
    [style.--count-of-items]="list.length"
  >
    @for (tile of list; track tile) {
      <kehe-phoenix-announcement-card
        [state]="tile.state"
        [headline]="tile.header"
        [preview]="tile.subHeader"
        (clicked)="readMore(tile.id)"
      >
      </kehe-phoenix-announcement-card>
    }
    @if (getMobileConfig(list); as linksConfig) {
      <kehe-phoenix-announcement-links
        [state]="linksConfig?.state"
        [headline]="linksConfig?.headline"
        [links]="linksConfig?.links"
      >
      </kehe-phoenix-announcement-links>
    }
  </div>
}
